<template>
  <a :href="this.notification.data.profile_url" class="notification-item-wrap notification-item-wrap_green_cup">
    <div class="event-name">
      <a :href="this.notification.data.profile_url">
        {{ I18n.t("sport_competitions.title") }}
      </a>
    </div>

    <div class="notification-item">
      <div class="notification-item-message">
        <span class="notification-item-img">
          <img :src="this.notification.data.profile_image" loading="lazy" v-if="!!this.notification.data.profile_image">
          <span v-else class="nickname">@{{ this.notification.data.profile_nickname }}</span>
        </span>
        <span class="notification-item-img-msg">
          {{ I18n.t("sport_competitions.notifications.sport_competition_challenge_accepted") }}
        </span>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      notification: Object,
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
</style>
